import React, { useState } from "react";
import doubblequotestop from "../../../assets/images/Icons/HomePage - Icons/testimonials-top.svg";
import doubblequotesbottom from "../../../assets/images/Icons/HomePage - Icons/testimonials-bottom.svg";
import nelson from "../../../assets/images/Images/Home-Images/nelsonHall.png";
import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";

type Props = {};

const TestimonialData2 = (props: Props) => {
  const [show, setShow] = useState(false);
  return (
    <>
      {/* Mobile */}
      <div className="d-block d-md-none">
        <div
          className="p-20 bg-mobile-testimonials radius-20"
          style={{ height: "570px" }}
        >
          <h3 className=" header-color d-flex justify-content-center font-family-roboto align-items-center font-20 fonts-800 line-23 py-20 pb-80">
            Testimonials and Awards
          </h3>

          <div className="section4 container">
            <div className="row ">
              <div className="col-md-6 col-sm-12 col-12 ps-4 gap-10">
                <img
                  className="wx-27 hx-21"
                  src={doubblequotestop}
                  alt={"doubble quotes"}
                />
                <p className="text-black-10 font-12 font-family-roboto line-23 fonts-400 ml-5">
                  Yantr.ai as a product has created quite a bit of ripple in the
                  Field Service Management market with composable technologies
                  working in tandem with its operational purview accelerating
                  CX, Growth, and a Transformation Journey for clients adapting
                  to it.
                </p>
                <div className="d-flex justify-content-end mt-3">
                  <img
                    className="wx-27 hx-21 text-right"
                    src={doubblequotesbottom}
                    alt="doubble quotes bottom"
                  />
                </div>
                <div className="col-md-12 col-sm-6 col-12 mt-40 d-flex flex-row gap-10 pb-90">
                  <div className="col-md-3 col-sm-12 col-12 d-flex gap-2">
                    <div className="d-flex">
                      <img
                        className="wx-90 hx-90"
                        src={nelson}
                        alt={"person"}
                      />
                    </div>
                    <div className="m-1 pt-20">
                      <p className="text-primary1 font-12 fonts-800 font-family-roboto-flex line-14">
                        NelsonHall Online Journal Publication
                      </p>
                      <div className={`buttongroup`}>
                        <div className=" d-flex justify-content-start pt-20">
                          <Button
                            textclass="font-16 fonts-500 line-19 font-family-roboto-flex justify-content-center"
                            className="wx-107 hx-30 text-color-success text-center justify-content-center radius-5"
                            text="Read More"
                            onClick={()=>window.open('https://research.nelson-hall.com/blogs-webcasts/nelsonhall-blog/?avpage-views=blog&type=post&post_id=1214')}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Website */}
      <div className="d-none d-md-block radius-20">
        <h3 className="header-color d-flex justify-content-center font-family-roboto align-items-center font-30 fonts-800 line-35 py-40">
          Testimonials and Awards
        </h3>
        <div className="section4 container" style={{ height: "400px" }}>
          <div className="row">
            <div className="col-md-4 d-flex justify-content-center align-items-center">
              <img className="wx-256 hx-256" src={nelson} alt={"nelsonHall"} />
            </div>
            <div className="col-md-7 ps-4">
              <h3 className="header-color d-flex font-family-roboto-flex font-22 fonts-800 line-35 py-40">
                NelsonHall Online Journal Publication
              </h3>
              <p className="text-black-10 font-18 font-family-roboto line-24 fonts-400 ml-5">
                Yantr.ai as a product has created quite a bit of ripple in the
                Field Service Management market with composable technologies
                working in tandem with its operational purview accelerating CX,
                Growth, and a Transformation Journey for clients adapting to it.
              </p>
              <div className={`buttongroup`}>
                <div className=" d-flex justify-content-start mt-30">
                  <Button
                    textclass="font-16 fonts-500 line-19 font-family-roboto-flex justify-content-center"
                    className="wx-147 hx-40 text-color-success text-center justify-content-center radius-5"
                    text="Read More"
                    onClick={()=>window.open('https://research.nelson-hall.com/blogs-webcasts/nelsonhall-blog/?avpage-views=blog&type=post&post_id=1214')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestimonialData2;
